import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  filePicker: {
    textAlign: 'left',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '5px',
    padding: '8px',

    '& p': {
      marginTop: '0',
      marginBottom: '8px'
    },

  },

  content: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  form: {
    display: 'flex',
    alignItems: 'flex-end',
    width: 'calc(100% - 40px)',

    '& > p ': {
      paddingLeft: '8px',
      width: 'calc(100% - 60px)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '& > div': {
      width: '50px',
      height: '60px',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '5px',
      transition: 'transform ease-in-out .2s',

      '&:hover': {
        transform: 'scale(1.1)'
      },

      '& >  input': {
        width: '100%',
        height: '100%',
        outline: 'none',
        cursor: 'pointer',
        background: '#eee'
      },

      '&  > .MuiIconButton-root': {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        borderRadius: '0',
        pointerEvents: 'none',
        background: '#eee'
      }
    },
  },

  actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  delete: {
    color: theme.palette.danger.main,
    transition: 'background-color ease .2s',

    '&:hover': {
      backgroundColor: theme.palette.danger.light,
    }
  }

}))